/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum SubscriptionType {
  apple = 'apple',
  stripe = 'stripe'
}

/**
 * SubscriptionType
 *
 * The supported backing snapshot from providers.
 */
export const SubscriptionTypeEnumType = types.enumeration('SubscriptionType', ['apple', 'stripe'])
